module.exports = __webpack_public_path__ + "img/stick_hiver_plaisir_hiver.4766fa21.svg";